import React, { useState } from 'react';
import { validatePhoneNumber } from '../utils/validation';
import ActionButton from '../../../shared/components/action-button/ActionButton';
import './TestSMSButton.css';

const TestSMSButton = ({ onSendTest, disabled, defaultMessage = '' }) => {
  const [open, setOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [customMessage, setCustomMessage] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const handleOpen = () => {
    setCustomMessage(defaultMessage || '');
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setPhoneNumber('');
    setCustomMessage('');
    setError('');
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    const numbers = value.replace(/[^\d+]/g, '');
    
    // Handle international format
    if (numbers.startsWith('+')) {
      // For international numbers, group by 3s after country code
      const groups = numbers.slice(1).match(/.{1,3}/g) || [];
      return '+' + groups.join(' ');
    }
    
    // For US numbers
    if (numbers.length <= 10) {
      const areaCode = numbers.slice(0, 3);
      const middle = numbers.slice(3, 6);
      const last = numbers.slice(6, 10);

      if (numbers.length <= 3) return numbers;
      if (numbers.length <= 6) return `(${areaCode}) ${middle}`;
      return `(${areaCode}) ${middle}-${last}`;
    }

    return numbers;
  };

  const handlePhoneNumberChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
    setError('');
  };

  const handleSend = async () => {
    const normalizedNumber = phoneNumber.replace(/[\s()-]/g, '');
    if (!validatePhoneNumber(normalizedNumber)) {
      setError('Please enter a valid phone number');
      return;
    }

    try {
      setSending(true);
      await onSendTest(normalizedNumber, customMessage?.trim() ? customMessage.trim() : undefined);
      handleClose();
    } catch (err) {
      setError('Failed to send test SMS');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <ActionButton type="button" onClick={handleOpen} disabled={disabled}>
        Send Test SMS
      </ActionButton>

      {open && (
        <div className="sms-test-modal" role="dialog" aria-modal="true" aria-label="Send test SMS">
          <div className="sms-test-modal__backdrop" onClick={handleClose} />
          <div className="sms-test-modal__panel">
            <div className="sms-test-modal__header">
              <h3>Send Test SMS</h3>
              <button type="button" className="sms-test-modal__close" onClick={handleClose}>
                x
              </button>
            </div>

            {error && <div className="sms-test-modal__error">{error}</div>}

            <label className="sms-test-modal__field">
              <span>Phone number</span>
              <input
                autoFocus
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                maxLength={16}
                placeholder="+1 234 567 8900"
              />
              <small>Enter a valid phone number, such as `+1 234 567 8900`.</small>
            </label>

            <label className="sms-test-modal__field">
              <span>Custom message (optional)</span>
              <textarea
                rows={4}
                value={customMessage}
                onChange={(event) => setCustomMessage(event.target.value)}
                placeholder="If left blank, your current template will be used."
              />
            </label>

            <div className="sms-test-modal__actions">
              <button type="button" className="sms-test-modal__button sms-test-modal__button--secondary" onClick={handleClose}>
                Cancel
              </button>
              <button
                type="button"
                className="sms-test-modal__button sms-test-modal__button--primary"
                onClick={handleSend}
                disabled={sending}
              >
                {sending ? 'Sending...' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TestSMSButton; 